'use client'

import { useEffect, useRef } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

export function ViewerTracker() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const lastPathRef = useRef<string | null>(null)

  useEffect(() => {
    const query = searchParams?.toString()
    const path = query ? `${pathname}?${query}` : pathname
    if (!path || lastPathRef.current === path) return
    lastPathRef.current = path
    fetch('/api/public/track-viewer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ path }),
      keepalive: true,
    }).catch(() => undefined)
  }, [pathname, searchParams])

  return null
}
